import React from "react";
import {DesignerStore} from "controls/designer/designerStore";

export const DataSourceEditorContext = React.createContext<DesignerStore>(null)
